<template>
  <div class="AdBlock PrivewDialog" >
    <div v-if="!compactHeader" class="PrivewDialogHeader">
      <div class="PrivewDialogTitle">
        {{
          langId === "1252"
            ? "Ad " + $t("lbl_EMPBE_Preview")
            : $t("Lbl_Advertisement") + $t("lbl_EMPBE_Preview")
        }}
      </div>
      <div>
        <slot></slot> <!--右上角按钮（将被样式增强并自动带小眼睛）-->
      </div>
    </div>

    <div class="PrivewDialogBody">
      <!-- ===== bannerAd（只用 PcUrl/MbUrl） ===== -->
      <div v-if="AdType === 'bannerAd'" >
        <div class="banner-preview">
          <template v-if="!IsCpsEMarketplace">
            <!-- Desktop -->
            <div class="banner-section">
              <div class="banner-head">
                <span class="banner-head__title">{{ $t('Desktop') }}</span>

                <!-- Tooltip：仅 hover 显示；离开即消失（不用 focus，避免长按/点击后残留） -->
                <span class="badge-wrap" aria-describedby="tips-ebooth-url-desktop">
                  <span class="badge">{{ $t('Bilingual') }}</span>
                  <div id="tips-ebooth-url-desktop" class="tips-pop" role="tooltip" aria-live="polite">
                    <div class="tips-box">
                      <i class="tips-arrow" aria-hidden="true"></i>
                      <h4 class="tips-title">{{ $t('BilingualTip') }}</h4>
                    </div>
                  </div>
                </span>
              </div>
              <div class="banner-body">
                <div
                  data-logo="CPS"
                  data-property-1="Desktop"
                  data-version="3"
                  class="banner-canvas-box banner-canvas--pc"
                  :style="{ backgroundImage: `url('${bannerPcUrl}')` }"
                >
                </div>
              </div>
            </div>

            <!-- Mobile -->
            <div class="banner-section">
              <div class="banner-head">
                <span class="banner-head__title">{{ $t('Mobile') }}</span>

                <!-- Tooltip：仅 hover 显示；离开即消失 -->
                <span class="badge-wrap" aria-describedby="tips-ebooth-url-mobile">
                  <span class="badge">{{ $t('Bilingual') }}</span>
                  <div id="tips-ebooth-url-mobile" class="tips-pop" role="tooltip" aria-live="polite">
                    <div class="tips-box">
                      <i class="tips-arrow" aria-hidden="true"></i>
                      <h4 class="tips-title">{{ $t('BilingualTip') }}</h4>
                    </div>
                  </div>
                </span>
              </div>

              <div class="banner-body banner-body--mobile">
                <div
                  data-logo="CPS"
                  data-property-1="mobile"
                  data-version="3"
                  class="banner-canvas-box banner-canvas--mb"
                  :style="{ backgroundImage: `url('${bannerMbUrl}')` }"
                >
                </div>
              </div>
            </div>
          </template>

          <!-- 当 IsCpsEMarketplace 为 true 时，显示 Desktop 3 + Mobile 4 -->
          <template v-else>
            <!-- Desktop 3 -->
            <div class="banner-section">
              <div class="banner-head">
                <span class="banner-head__title">{{ $t('Desktop') }} </span>

                <!-- Tooltip：仅 hover 显示；离开即消失 -->
                <span class="badge-wrap" aria-describedby="tips-ebooth-url-desktop3">
                  <span class="badge">{{ $t('Bilingual') }}</span>
                  <div id="tips-ebooth-url-desktop3" class="tips-pop" role="tooltip" aria-live="polite">
                    <div class="tips-box">
                      <i class="tips-arrow" aria-hidden="true"></i>
                      <h4 class="tips-title">{{ $t('BilingualTip') }}</h4>
                    </div>
                  </div>
                </span>
              </div>
              <div class="banner-body">
                <div
                  data-logo="CPS"
                  data-property-1="Desktop"
                  data-version="3"
                  class="banner-canvas-box banner-canvas--pc"
                  :style="{ backgroundImage: `url('${bannerPc3Url}')` }"
                >
                </div>
              </div>
            </div>

            <!-- Mobile 4 -->
            <div class="banner-section">
              <div class="banner-head">
                <span class="banner-head__title">{{ $t('Mobile') }} </span>

                <!-- Tooltip：仅 hover 显示；离开即消失 -->
                <span class="badge-wrap" aria-describedby="tips-ebooth-url-mobile4">
                  <span class="badge">{{ $t('Bilingual') }}</span>
                  <div id="tips-ebooth-url-mobile4" class="tips-pop" role="tooltip" aria-live="polite">
                    <div class="tips-box">
                      <i class="tips-arrow" aria-hidden="true"></i>
                      <h4 class="tips-title">{{ $t('BilingualTip') }}</h4>
                    </div>
                  </div>
                </span>
              </div>

              <div class="banner-body banner-body--mobile">
                <div
                  data-logo="CPS"
                  data-property-1="mobile"
                  data-version="3"
                  class="banner-canvas-box banner-canvas--mb"
                  :style="{ backgroundImage: `url('${bannerMb4Url}')` }"
                >
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- ===== logoAd（使用 data 媒体） ===== -->
      <div v-else-if="AdType === 'logoAd'">
        <!-- LocationIndex = 0：Variant2 三列（大格仅第1个用数据） -->
        <section v-if="Number(LocationIndex) === 0" class="logoV2" data-property-1="Variant2">

          <div class="logoV2__col" v-for="(col, ci) in 1" :key="'v2-col-' + ci">
                  <div class="logoV2__Title">{{ $t('lbl_EMPBE_ALargeSize') }}</div>
            <!-- 顶部大格 216×216 -->
            <div class="logoV2__box logoV2__box--lg" :data-show-chinaplas-logos="ci !== 0">
              <div class="logoV2__inner">
                <img v-if="ci === 0" :src="logoV2_first" alt="Main" loading="lazy" />
                <template v-else>
                  <div class="logoV2__ph"></div>
                  <div class="chinaplas-logos chinaplas-logos--lg">
                    <img
                      class="ph-center ph-logo-lg"
                      src="https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd1.png?version=20250909_1635&resize,h_64,limit_1"
                      alt="" aria-hidden="true"
                    />
                  </div>
                </template>
              </div>
            </div>

            <!-- 底部两个 100×100：仅第 3、6 格使用数据，其余用 logoAd2 -->
            <!-- <div class="logoV2__rowSm">
              <div
                class="logoV2__box logoV2__box--sm"
                v-for="si in 2"
                :key="'v2-sm-' + ci + '-' + si"
                :data-show-chinaplas-logos="!logoV2_smFixed[ci*2 + (si-1)]"
              >
                <div class="logoV2__inner logoV2__inner--sm">
                  <img
                    v-if="logoV2_smFixed[ci*2 + (si-1)]"
                    :src="logoV2_smFixed[ci*2 + (si-1)]"
                    alt="Thumb" loading="lazy"
                  />
                  <template v-else>
                    <div class="logoV2__ph"></div>
                    <div class="chinaplas-logos chinaplas-logos--sm">
                      <img
                        class="ph-center ph-logo-sm"
                        src="https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd2.png?version=20250909_1635&resize,h_64,limit_1"
                        alt="" aria-hidden="true"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div> -->
          </div>
          <div
                class="logoV2__box  logoV2__col"
                :data-show-chinaplas-logos="logoV2_first"
              >
                <div class="logoV2__Title">{{ $t('lbl_EMPBE_ASmallSize') }}</div>
                <div class="logoV2__inner logoV2__inner--sm logoV2__box--sm">
                  <img  :src="logoV2_first" alt="Main" loading="lazy" />
                </div>
              </div>
        </section>

        <!-- LocationIndex = 1：卡片 -->
        <section v-else-if="Number(LocationIndex) === 1" class="logo-block" style="margin-top: 16px;">
          <div class="ad-card" data-property-1="Ad">
            <div class="ad-card__left">
              <img
                class="ad-card__logo"
                :src="(data && (data.Companylogo || data.photoFileName) && !forceDefault)
                      ? ((data.Companylogo || data.photoFileName) + '?x-oss-process=image/resize,h_200/format,webp')
                      : DEFAULT_MEDIA.logoAd.cardPh"
                alt="Company Logo"
                loading="lazy"
              />
              <div class="ad-card__meta">
                <!-- 文案始终来自 data（即使显示默认图片也保留公司名称） -->
                <h3
                  class="ad-card__name"
                  v-text="(data && (data.CompanyName || data.compName)) ? (data.CompanyName || data.compName) : '—'"
                ></h3>
                <ul class="ad-card__info-list">
                  <li class="ad-card__info-item"><span class="key">{{$t('lbl_EMPBE_LogoAd_ThemeZones')}}</span><span class="val">TBC</span></li>
                  <li class="ad-card__info-item"><span class="key">{{$t('lbl_EMPBE_LogoAd_Hall')}}</span><span class="val">TBC</span></li>
                  <li class="ad-card__info-item"><span class="key">{{$t('lbl_EMPBE_LogoAd_BoothNumber')}}</span><span class="val">TBC</span></li>
                </ul>
              </div>
            </div>
            <div class="ad-card__right">
              <span class="ad-card__tag">{{ $t('AD') }}</span>
              <button type="button" class="ad-card__btn ad-card__btn--primary">{{$t('lbl_EMPBE_LogoAd_ViewExhibitorDetail')}}</button>
              <button type="button" class="ad-card__btn ad-card__btn--secondary">{{$t('lbl_EMPBE_LogoAd_ViewProducts')}}</button>
            </div>
          </div>
        </section>

        <!-- LocationIndex = 2：圆形三连（logoAd3 固定像素，居中） -->
        <section v-else-if="Number(LocationIndex) === 2" class="logo-block">
          <div class="logo-row logo-row--sm logo-row--circle" style="width: 300px; gap: 24px;">
            <div
              class="logo-cell logo-cell--sm logo-cell--circle"
              :data-property-1="circle_first ? 'Variant3' : 'EMPS'"
              :data-show-chinaplas-logos="!circle_first"
            >
              <template v-if="circle_first">
                <img :src="circle_first" loading="lazy" alt="Company Logo" />
              </template>
              <template v-else>
                <div class="logo-placeholder"></div>
                <div class="chinaplas-logos chinaplas-logos--sm">
                  <img
                    class="ph-center ph-logo-sm"
                    src="https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd3.png?version=20250909_1635&resize,h_64,limit_1"
                    alt="" aria-hidden="true"
                  />
                </div>
              </template>
            </div>

            <!-- <div
              class="logo-cell logo-cell--sm logo-cell--circle"
              v-for="i in 2"
              :key="'l2-circle-ph-'+i"
              data-property-1="EMPS"
              data-show-chinaplas-logos="true"
            >
              <div class="logo-placeholder"></div>
              <div class="chinaplas-logos chinaplas-logos--sm">
                <img
                  class="ph-center ph-logo-sm"
                  src="https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd3.png?version=20250909_1635&resize,h_64,limit_1"
                  alt="" aria-hidden="true"
                />
              </div>
            </div> -->
          </div>
        </section>
      </div>

      <!-- ===== buttonAd（只用 PcUrl/MbUrl） ===== -->
      <div v-else-if="AdType === 'buttonAd'" class="btnad">
        <div class="btnad__list">
          <div
            class="btnad__card"
            data-property-1="Variant2"
            data-show-chinaplas-logos="false"
            data-show-sample-tag="false"
          >
            <div
              class="btnad__bg"
              :style="{ backgroundImage: `url('${btnad_first}')` }"
            >
            </div>
          </div>
        </div>
      </div>

      <!-- ===== landingAd（主图与头像都走 PcUrl/MbUrl） ===== -->
      <div
        v-else-if="AdType === 'landingAd'"
        class="landingad"
        :class="{ 'landingad--cover': isDefault_landing }"
      >
        <!-- Tooltip：详情页 header 已展示双语提示，此处仅非 compact 时显示 -->
        <div v-if="!compactHeader" class="landingad__badge">
          <span class="badge-wrap" aria-describedby="tips-ebooth-url-landing">
            {{ $t('Bilingual') }}
            <div id="tips-ebooth-url-landing" class="tips-pop" role="tooltip" aria-live="polite">
              <div class="tips-box">
                <i class="tips-arrow" aria-hidden="true"></i>
                <h4 class="tips-title">{{ $t('BilingualTip') }}</h4>
              </div>
            </div>
          </span>
        </div>

        <div class="landingad__card">
          <img
            class="landingad__hero"
            :src="landing_heroSrc"
            :alt="landing_companyName || landing_defaults.companyName"
            loading="lazy"
          />
          <!-- 默认图时隐藏 Meta；图片要铺满且无白边 -->
          <div class="landingad__meta" v-if="!isDefault_landing">
            <img class="landingad__avatar" :src="companyLogoSrc" alt="Company Avatar" loading="lazy" />
            <div class="landingad__meta-main">
              <div class="landingad__company">
                {{ landing_companyName || landing_defaults.companyName }}
              </div>
              <div class="landingad__chips">
                <span
                  v-for="(t, i) in (landing_tags.length ? landing_tags : landing_defaults.tags)"
                  :key="i"
                  class="landingad__chip"
                >
                  {{ t }}
                </span>
              </div>
            </div>
            <button type="button" class="landingad__cta">
              {{ ($t && $t('Lbl_ExploreNow') && $t('Lbl_ExploreNow') !== 'Lbl_ExploreNow')
                ? $t('Lbl_ExploreNow')
                : landing_defaults.cta }}
            </button>
          </div>
        </div>
      </div>

      <!-- ===== videoAd（使用 data 媒体） ===== -->
      <div v-else-if="AdType === 'videoAd'" class="ad-container">
        <template v-if="!isDefault_videoPoster">
          <div 
            class="ad-frame ad-frame--clickable" 
            :class="Number(LocationIndex) === 0 ? 'ad-frame--sm' : 'ad-frame--lg'"
            @click="handleVideoClick"
          >
            <img
              loading="lazy"
              :src="video_posterSrc"
              class="img mw-100 mh-100 w-100 h-100"
              style="object-fit: cover;"
            />
            <!-- 默认海报时不显示播放按钮（避免重叠） -->
            <div class="ad-play" aria-hidden="true">
              <img class="ad-play__icon" :src="playIconSrc" alt="" />
            </div>
          </div>
        </template>
        <!-- 默认海报时不显示点击区域 -->
        <template v-else>
          <div class="ad-frame" :class="Number(LocationIndex) === 0 ? 'ad-frame--sm' : 'ad-frame--lg'">
            <img
              loading="lazy"
              :src="video_posterSrc"
              class="img mw-100 mh-100 w-100 h-100"
              style="object-fit: cover;"
            />
          </div>
        </template>
      </div>

      <!-- ===== starAd（使用 data 媒体） ===== -->
      <div
        v-else-if="AdType === 'starAd'"
        class="starad"
        :class="{ 'starad--cover': isDefault_star }"
      >
        <!-- 默认图：整块覆盖（图片内已含文案） -->
        <template v-if="isDefault_star">
          <img class="starad__img starad__img--cover" :src="star_imageSrc" alt="Star Ad" loading="lazy" />
        </template>
        <!-- 非默认：图片 + 标题 -->
        <template v-else>
          <img class="starad__img" :src="star_imageSrc" alt="Star Ad" loading="lazy" />
          <div class="starad__title">{{ star_titleText ?? $t("lbl_EMPBE_StarAd_ProductName")}}</div>
        </template>
      </div>

      <!-- ===== catListAd（使用 data 媒体） ===== -->
      <div
        v-else-if="AdType === 'catListAd'"
        class="catlistad"
        :class="{ 'catlistad--full': isDefault_catList }"
      >
        <!-- 默认图：整块覆盖（图片内已含标题/公司/AD等设计） -->
        <template v-if="isDefault_catList">
          <img class="catlistad__full" :src="cat_thumbSrc" alt="Category Ad" loading="lazy" />
        </template>
        <!-- 非默认：原结构 -->
        <template v-else>
          <div class="catlistad__thumb" data-ranking="No" data-show-rank-number="true" data-size="M" data-ver="1">
            <img :src="cat_thumbSrc" alt="Thumbnail" loading="lazy" />
          </div>
          <div class="catlistad__main">
            <div class="catlistad__title">{{ cat_titleText ?? $t("lbl_EMPBE_StarAd_ProductName")}}</div>
            <div class="catlistad__subtitle">{{ cat_subtitleText ?? $t("lbl_EMPBE_LogoAd_DefaultCompanyName")}}</div>
          </div>
          <div class="catlistad__badge">{{ $t('AD') }}</div>
        </template>
      </div>

      <!-- ===== priorityAd（主图走 PcUrl/MbUrl；默认显示两张你提供的图） ===== -->
      <div v-else-if="AdType === 'priorityAd'">
        <div class="productCard">
          <div class="imageWrapper">
            <div class="imageContainer">
              <!-- 默认：显示两张默认图（并排） -->
              <template v-if="isDefault_priority">
                <div class="priority-default-grid">
                  <img
                    v-for="(src, idx) in DEFAULT_MEDIA.priorityAd1.defaults"
                    :key="'priority-default-' + idx"
                    :src="src"
                    loading="lazy"
                    class="img w-100 h-100"
                    style="object-fit: contain;"
                    alt="Priority Default"
                  />
                </div>
              </template>
              <!-- 非默认：显示单张真实主图 -->
              <template v-else>
                <img
                  loading="lazy"
                  :src="priority_mainSrc || 'https://placehold.co/600x600'"
                  class="img mw-100 mh-100 w-100 h-100"
                  style="object-fit: contain;"
                />
              </template>
            </div>
            <div class="iconBtns">
              <div class="iconBtnContainer">
                <i class="fa fa-star-o" style="transform: translate(0px, 1px)"></i>
              </div>
              <div class="iconBtnContainer">
                <i class="fa fa-share-square-o" style="transform: translate(1px, 2px)"></i>
              </div>
            </div>
          </div>

          <div class="contentContainer">
            <div class="productApps">
              <div v-for="(item, index) in applicattoins" :key="index" class="app_badge">
                {{ item }}
              </div>
              <span v-if="remainingAppli > 0" class="app_badge">
                {{ remainingAppli }}+
              </span>
            </div>

            <div class="productName">{{ data?.productName }}</div>
            <div class="productDesc">{{ data?.productDesc }}</div>
            <div class="companyName">{{ data?.compName }}</div>

            <div class="mt-1">
              <div class="btns">
                <div class="enquire-btn">
                  <i class="fa fa-comments-o"></i>
                  <span>{{ $t("lbl_EMP2_EnquireNow") }}</span>
                </div>
                <div class="sendcard-btn">
                  <img
                    src="https://cdn.adsalecdn.com/EMP/2-0/EnquiryForm/SendCard.svg"
                    alt=""
                    width="16"
                    height="16"
                    class="sendcard-btn__icon"
                  />
                  <span>{{ $t("lbl_EMP2_SendCard") }}</span>
                </div>
              </div>

              <div v-if="data?.productTags && data.productTags.length > 0">
                <div class="product-tags-container" ref="tagBox">
                  <span v-for="(item, index) in data.productTags" :key="index">
                    #{{ item }}
                  </span>
                </div>
                <span v-if="isShowMoreBtn" class="more-btn">
                  {{ $t("Lbl_ClickMore").toLowerCase() }}
                </span>
              </div>
            </div>

            <!-- ✅ 两张 72×72 小图 -->
            <!-- <div v-if="data?.otherProducts && data.otherProducts.length > 0">{{ $t("lbl_OtherProducts") }}</div> -->
            <div class="pair-tiles" v-if="AdType==='priorityAd'">
              <!-- <div
                v-for="(src, idx) in priority_tiles"
                :key="'pair-tile-' + idx"
                class="pair-tiles__item"
              >
                <img v-if="src" :src="src" loading="lazy" alt="" />
              </div> -->
            </div>

            <div v-if="data?.otherProducts && data.otherProducts.length > 0" class="other-products-container">
              <div class="other-products-text">{{ $t("lbl_OtherProducts") }}</div>
              <div class="other-products">
                <img
                  v-for="(item, index) in data.otherProducts"
                  :key="index"
                  loading="lazy"
                  :src="item.FileName + '?x-oss-process=image/resize,h_200/format,webp'"
                  class="img mw-100 mh-100 w-100 h-100"
                />
              </div>
            </div>
          </div>

          <div class="adLabel">{{ $t("Lbl_Advertisement") }}</div>
        </div>
      </div>

      <!-- 视频播放对话框 -->
      <b-modal 
        id="videoPlayerModal" 
        :title="$t('lbl_EMPBE_Preview')" 
        size="lg" 
        centered
        :hide-footer="true"
        v-model="showVideoModal"
        @hidden="handleVideoModalClose"
        class="video-player-modal"
      >
        <div class="video-player-wrapper">
          <video 
            v-if="videoUrl"
            ref="videoPlayer"
            :src="videoUrl" 
            controls 
            class="video-player"
            :poster="video_posterSrc"
            controlslist="nodownload"
            preload="metadata"
          >
            <source :src="videoUrl" type="video/mp4">
            <source :src="videoUrl" type="video/webm">
            Your browser does not support the video tag.
          </video>
          <div v-else class="video-loading">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">{{ $t('lbl_EMPBE_Loading') || 'Loading...' }}</span>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { adService, CompanyInfoService } from "../../_services";

/* 统一默认图（集中在本文件，不新建 JS） */
const DEFAULT_MEDIA = {
  bannerAd: {
    pc: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/bannerAd_default111.png",
    mb: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/bannerAd_default2.png",
    pc3: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/bannerAd_Newdefault3.png",
    mb4: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/bannerAd_Newdefault4.png",
  },
  logoAd: {
    v2lg:  "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default1.png?version=20250909_1635&resize,h_64,limit_1",
    v2sm:  "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default2.png?version=20250909_1635&resize,h_64,limit_1",
    circle:"https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default3.png?version=20250909_1635&resize,h_64,limit_1",
    cardPh:"https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default4.png?version=20250909_1635&resize,h_64,limit_1",
  },
  buttonAd: {
    first: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/buttonAd_default1.png?version=20250909_1635&resize,h_64,limit_1",
  },
  videoAd: {
    /* ✅ 按位区分基地址：小位 default1，大位 default3（不带 x-oss-process） */
    poster_sm_base: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/videoAd_default1.png?version=20250909_1635",
    poster_lg_base: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/videoAd_default3.png?version=20250909_1635"
  },

  priorityAd: {
    defaults: [
      "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/priorityAd_default1.png?version=20250909_1635&resize,h_64,limit_1",
      "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/priorityAd_default2.png?version=20250909_1635&resize,h_64,limit_1",
    ]
  },
  priorityAd1: {
    defaults: [
      "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/priorityAd_default1.png?version=20250909_1635&resize,h_64,limit_1",
    ]
  }
};

export default {
  props: {
    AdType: {
      type: String,
      default: "bannerAd"
    },
    productId: { type: Number, default: 0 },
    companyId: { type: [String, Number], default: '0' },
    PcUrl: { type: String, default: "" },
    MbUrl: { type: String, default: "" },
    isShowMoreBtn: { type: Boolean, default: false },
    LocationIndex: { type: Number, default: 0 },
    /* 新增：一键查看默认图（只替换图片，不影响文字/数据加载） */
    forceDefault: { type: Boolean, default: false },
    IsCpsEMarketplace: { type: Boolean, default: false },
    compactHeader: { type: Boolean, default: false },
  },
  data() {
    return { 
      loading: false, 
      data: null, 
      companyLogo: "",
      DEFAULT_MEDIA,
      showVideoModal: false,
      videoUrl: "",
      videoLoading: false
    };
  },
  computed: {
    companyLogoSrc() {
      return this.companyLogo || "https://cdn.adsalecdn.com/EMP/Backend/Upload/Image/1036654_20251107111559683.webp?x-oss-process=image/resize,h_96/format,webp" ;
    },
    langId() {
      return localStorage.getItem("currentLangId");
    },
    starAdimg() {
      return   `https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/starAd_${this.langId}_default3.png?version=20250909_1635&resize,h_64,limit_1 `;
    },
    landingAdhero() {
      return `https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/landingAd_${this.langId}_default2.png?version=20250909_1635&resize,h_64,limit_1`;
    },
    catListAdthumb() {
      return `https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/catListAd_${this.langId}_default1.png?version=20250909_1635&resize,h_64,limit_1`;
    },
    /* === 统一的素材来源开关：只在这四种里走 data，其它走 PcUrl/MbUrl === */
    useDataMedia() {
      return ['logoAd', 'videoAd', 'starAd', 'catListAd','priorityAd'].includes(this.AdType);
    },

    playIconSrc() {
      const h = Number(this.LocationIndex) === 0 ? 56 : 96;
      return `https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/play_circle.png?version=20250909_1635&resize,h_${h},limit_1`;
    },

    /* ===== bannerAd ===== */
    bannerPcUrl() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.bannerAd.pc;
      const u = (this.PcUrl || "").trim();
      return u || this.DEFAULT_MEDIA.bannerAd.pc;
    },
    bannerMbUrl() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.bannerAd.mb;
      const u = (this.MbUrl || "").trim();
      return u || this.DEFAULT_MEDIA.bannerAd.mb;
    },
    bannerPc3Url() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.bannerAd.pc3;
      const u = (this.PcUrl || "").trim();
      return u || this.DEFAULT_MEDIA.bannerAd.pc3;
    },
    bannerMb4Url() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.bannerAd.mb4;
      const u = (this.MbUrl || "").trim();
      return u || this.DEFAULT_MEDIA.bannerAd.mb4;
    },

    /* ===== buttonAd ===== */
    btnad_first() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.buttonAd.first;
      const u = (this.PcUrl || "").trim();
      return u||this.pickMedia({ h: 90, allowCompanyLogo: false }) || this.DEFAULT_MEDIA.buttonAd.first;
    },
    isDefault_btnad() {
      return this.forceDefault || this.btnad_first === this.DEFAULT_MEDIA.buttonAd.first;
    },

    /* ===== logoAd ===== */
    circle_first() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.logoAd.circle;
      return this.pickMedia({ h: 100, allowCompanyLogo: true }) || this.DEFAULT_MEDIA.logoAd.circle;
    },
    logoV2_first() {
      if (this.forceDefault) return this.DEFAULT_MEDIA.logoAd.v2lg;
      return this.pickMedia({ h: 216, allowCompanyLogo: true }) || this.DEFAULT_MEDIA.logoAd.v2lg;
    },
    logoV2_smFixed() {
      if (this.forceDefault) {
        const out = Array(6).fill(null);
        out[2] = this.DEFAULT_MEDIA.logoAd.v2sm;
        out[5] = this.DEFAULT_MEDIA.logoAd.v2sm;
        return out;
      }
      const baseRaw =
        (this?.data?.photoFileName ||
         this?.data?.Companylogo ||
         "");
      const fallback = baseRaw ? this.ossResize(baseRaw, 100) : this.DEFAULT_MEDIA.logoAd.v2sm;
      const rest = this.allImageSrcs.slice(1);
      const out = Array(6).fill(null);
      const showIdx = [2, 5];
      let p = 0;
      showIdx.forEach((idx) => {
        out[idx] = rest[p] ? this.ossResize(rest[p++], 100) : fallback;
      });
      return out;
    },

    /* ===== starAd / catListAd ===== */
    star_imageSrc() {
      if (this.forceDefault) return this.starAdimg;
      const src = this.pickMedia({ h: 200, allowCompanyLogo: true });
      return src || this.starAdimg;
    },
    star_titleText() {
      const d = this?.data || {};
      return d.productName || d.CompanyName || d.compName || "CHINAPLAS 2026";
    },
    isDefault_star() {
      return this.star_imageSrc === this.starAdimg;
    },

    cat_thumbSrc() {
      if (this.forceDefault) return this.catListAdthumb;
      const src = this.pickMedia({ h: 78, allowCompanyLogo: true });
      return src || this.catListAdthumb;
    },
    isDefault_catList() {
      return this.cat_thumbSrc === this.catListAdthumb;
    },
    cat_titleText() {
      const d = this?.data || {};
      return d.productName || "CHINAPLAS 2026";
    },
    cat_subtitleText() {
      const d = this?.data || {};
      return d.compName || d.CompanyName || this.landing_defaults.companyName;
    },

    /* ===== landingAd ===== */
    landing_defaults() {
      return {
        companyName: this.$t("lbl_EMPBE_LogoAd_DefaultCompanyName"),
        tags: [this.$t("lbl_EMPBE_LandingAd_Electronicmedia"),this.$t("lbl_EMPBE_LandingAd_Other")],
        cta: this.$t("lbl_EMPBE_LandingAd_ExploreNow")
      };
    },
    landing_heroSrc() {
      if (this.forceDefault) return this.landingAdhero;
      const url = (this.PcUrl && this.PcUrl.trim()) ? this.PcUrl : (this.MbUrl && this.MbUrl.trim()) ? this.MbUrl : "";
      return url || this.landingAdhero;
    },
    landing_avatarSrc() {
      const url = this.forceDefault
        ? this.landingAdhero
        : (this.PcUrl && this.PcUrl.trim()) ? this.PcUrl : (this.MbUrl && this.MbUrl.trim()) ? this.MbUrl : this.landingAdhero;
      return this.ossResize(url, 96);
    },
    landing_companyName() {
      return this?.data?.CompanyName || this?.data?.compName || "";
    },
    landing_tags() {
      if (Array.isArray(this?.data?.productApps) && this.data.productApps.length)
        return this.data.productApps;
      return Array.isArray(this?.data?.productTags) ? this.data.productTags : [];
    },
    isDefault_landing() {
      return this.landing_heroSrc === this.landingAdhero;
    },

    /* ===== videoAd（按位选择 default1 / default3） ===== */
    video_posterSrc() {
      const isSmall = Number(this.LocationIndex) === 0;
      const h = isSmall ? 187 : 450;
      const base = isSmall
        ? this.DEFAULT_MEDIA.videoAd.poster_sm_base   // 小位：default1
        : this.DEFAULT_MEDIA.videoAd.poster_lg_base;  // 大位：default3

      if (this.forceDefault) return this.ossResize(base, h);

      const cover = this?.data?.ExhibitVideo_cover || this?.data?.exhibitVideo_cover;
      if (cover) return this.ossResize(cover, h);

      const fromDataOrPcMb = this.pickMedia({ h, allowCompanyLogo: false });
      if (fromDataOrPcMb) return fromDataOrPcMb;

      return this.ossResize(base, h);
    },
    isDefault_videoPoster() {
      const { poster_sm_base, poster_lg_base } = this.DEFAULT_MEDIA.videoAd;
      const s = this.video_posterSrc || "";
      return s.startsWith(poster_sm_base) || s.startsWith(poster_lg_base);
    },

    /* ===== priorityAd ===== */
    priority_mainSrc() {
      if (this.forceDefault) return "";
      return this.pickMedia({ h: 600, allowCompanyLogo: false });
    },
    isDefault_priority() {
      return this.forceDefault || !this.priority_mainSrc;
    },

    priority_tiles() {
      const fallback = (this.DEFAULT_MEDIA?.priorityAd?.defaults?.[1]) || "";
      if (this.isDefault_priority) {
        return [fallback, fallback];
      }
      const list = Array.isArray(this?.data?.otherProducts) ? this.data.otherProducts : [];
      const urls = list.slice(0, 2).map(it => it?.FileName ? this.ossResize(it.FileName, 72) : "");
      while (urls.length < 2) urls.push(fallback);
      return urls;
    },

    logoMainSrc() {
      if (this.AdType !== 'logoAd' || this.forceDefault) return "";
      const base = (this?.data?.Companylogo || "").trim();
      return base ? `${base}?x-oss-process=image/resize,h_600/format,webp` : "";
    },
    otherProductsSafe() {
      return Array.isArray(this?.data?.otherProducts) ? this.data.otherProducts : [];
    },
    allImageSrcs() {
      const list = [];
      if (this.logoMainSrc) list.push(this.logoMainSrc);
      for (const it of this.otherProductsSafe) {
        if (it?.FileName) list.push(`${it.FileName}?x-oss-process=image/resize,h_200/format,webp`);
        }
      return list;
    },

    IsHasPrivew() {
      return !!(this.data || this.PcUrl || this.MbUrl);
    },
    langSE() {
      return this.langId === "1252" ? "EN" : (this.langId === "936" ? "SC" : "TC");
    },
    adPreviewLabel() {
      return this.langId === "1252"
        ? "Ad " + this.$t("lbl_EMPBE_Preview")
        : this.$t("Lbl_Advertisement") + this.$t("lbl_EMPBE_Preview");
    },
    applicattoins() {
      return (this.data?.productApps || []).slice(0, 2);
    },
    remainingAppli() {
      const n = (this.data?.productApps || []).length;
      return n > 2 ? n - 2 : 0;
    },
  },
  created() {
    if (this.productId > 0 && this.AdType !== "logoAd") {
      this.GetPreviewDetail(this.productId, this.companyId);
    }
    if (this.AdType === "logoAd") this.GetCompanyInfo(this.companyId);
  },
  watch: {
    productId() {
      if (this.AdType === "logoAd") return;
      this.GetPreviewDetail(this.productId, this.companyId);
    }
  },
  mounted() {
    this.initMoreBtn();
    this.GetCompanyLogo(this.$store.state.authentication.user.empCompanyId);
  },
  methods: {
    GetCompanyLogo(companyId) {
      CompanyInfoService.GetCompanyInfoAsync( {companyId} ).then(res => {
        if (res.isSuccessful) {
          this.companyLogo = res.data?.mediaFileList?.find(item => item.usageType.toLowerCase() === "companylogo")?.fileName ?? "";
        }
      });
    },
    pickMedia({ h = 200, allowCompanyLogo = false } = {}) {
      if (this.forceDefault) return "";
      let src = "";
      if (this.AdType === "logoAd") {
        src = (this?.data?.Companylogo || "").trim();
      } else if (this.useDataMedia) {
        src = this?.data?.photoFileName || (allowCompanyLogo ? this?.data?.Companylogo : "");
      } else {
        src = (this.PcUrl && this.PcUrl.trim()) ? this.PcUrl
             : (this.MbUrl && this.MbUrl.trim()) ? this.MbUrl
             : "";
      }
      return src ? this.ossResize(src, h) : "";
    },

    ossResize(src, h) {
      if (!src) return "";
      const sep = src.includes("?") ? "&" : "?";
      return `${src}${sep}x-oss-process=image/resize,h_${h}/format,webp`;
    },

    fillTo(arr, count, filler = null) {
      const out = arr.slice(0, count);
      while (out.length < count) out.push(filler);
      return out;
    },

    GetCompanyInfo(companyId) {
      CompanyInfoService.GetCompanyInfoAsync({ companyId }).then(res => {
        if (res.isSuccessful) {
          this.data = {
            Companylogo: res.data?.mediaFileList?.find(item => item.usageType.toLowerCase() === "companylogo")?.fileName ?? "",
            CompanyName: res.data?.companyEmp?.[this.langId == 1252 ? "nameEng" : (this.langId == 936) ? "nameSimp" : "nameTrad"] ?? ""
          }

          this.$emit("GetComapnyInfoMsg",this.data);
        }
      });
    },

    GetPreviewDetail(productId, companyId) {
      this.loading = true;
      this.data={};
      adService
        .GetAdPreviewDetail(parseInt(companyId), parseInt(productId))
        .then((res) => {
          if (res.isSuccessful && res.data) {
            this.data = {
              compName: res.data["compName" + this.langSE],
              productName: res.data["exhibitName" + this.langSE],
              productDesc: res.data["exhibitDesc" + this.langSE],
              ExhibitVideo_cover: res.data.exhibitVideo_cover,
              otherProducts: res.data.otherProducts ? JSON.parse(res.data.otherProducts) : [],
              photoFileName: res.data.photoFileName,
              productApps: this.ProductAppSpliter(res.data["productApp" + this.langSE]),
              productTags: this.ProductAppSpliter(res.data["productTag" + this.langSE]),
            };
          }
        })
        .finally(() => { this.loading = false; });
    },

    ProductAppSpliter(productAppsString) {
      if (!productAppsString) return [];
      return productAppsString.split("|");
    },

    initMoreBtn() {
      const box = this.$refs.tagBox;
      if (box) {
        const isTextOverflow = box.clientHeight < box.scrollHeight || box.clientWidth < box.scrollWidth;
        this.isShowMoreBtn = isTextOverflow;
      }
    },

    handleVideoClick() {
      // 如果是默认海报，不执行任何操作
      if (this.isDefault_videoPoster) {
        return;
      }
      
      // 显示对话框并获取视频URL
      this.showVideoModal = true;
      
      // 如果已经有视频URL，直接加载
      if (this.videoUrl) {
        this.$nextTick(() => {
          this.loadVideo();
        });
      } else {
        // 获取视频URL
        this.videoLoading = true;
        this.getVideoUrl();
      }
    },

    getVideoUrl() {
      if (!this.productId || !this.companyId) {
        this.videoLoading = false;
        return;
      }

      const params = {
        companyId: this.companyId,
        productId: this.productId
      };

      adService.getCompanyExhibitDetails(params)
        .then((res) => {
          if (res.isSuccessful && res.data) {
            const files = res.data.files || [];
            const videoFile = files.find(file => 
              file.usageType && file.usageType.toLowerCase() === 'exhibitvideo'
            );
            
            if (videoFile && videoFile.fileName) {
              this.videoUrl = videoFile.fileName;
              this.$nextTick(() => {
                this.loadVideo();
              });
            } else {
              this.videoUrl = "";
              this.$toast && this.$toast.error(this.$t('lbl_EMPBE_VideoNotFound') || 'Video not found');
            }
          } else {
            this.videoUrl = "";
            this.$toast && this.$toast.error(this.$t('lbl_EMPBE_VideoLoadError') || 'Failed to load video');
          }
        })
        .catch((error) => {
          console.error('Error loading video:', error);
          this.videoUrl = "";
          this.$toast && this.$toast.error(this.$t('lbl_EMPBE_VideoLoadError') || 'Failed to load video');
        })
        .finally(() => {
          this.videoLoading = false;
        });
    },

    loadVideo() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.load();
      }
    },

    handleVideoModalClose() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
        // 清空src以释放资源
        videoPlayer.src = "";
      }
      // 不清空videoUrl，以便下次快速打开
    },
  },
}
</script>

<style lang="scss" scoped>
/* =========================================================
   0) 基础与通用工具
   ======================================================= */
.PrivewDialogHeader{
  display:flex;align-items:center;align-self:stretch;justify-content:space-between;gap:7px;
  .PrivewDialogTitle{display:inline-flex;align-items:center;gap:6px;font-size:16px;font-weight:700;color:rgba(0,0,0,.8);}
}



/* 小屏增大可点区域 */
@media (max-width:576px){
  :deep(.TipsAndPrivewDilog .btn.btn-outline-primary){
    padding:8px 16px;font-size:15px;
  }
}

.badge{padding:4px 8px;background:rgba(0,0,0,.05);border-radius:4px;display:inline-flex;align-items:center;justify-content:center;gap:4px;font-size:12px;font-weight:500;color:rgba(0,0,0,.80);}
.ph-center{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;}
.ph-logo-lg{width:200.03px;height:34.56px;}
.ph-logo-sm{width:92.61px;height:16px;}
.ph-logo-btn{width:138.91px;height:24px;}
.chinaplas-logos{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;}

/* ==== Tooltip（高对比可读 + 双段 + 小箭头） ==== */
.badge-wrap { position: relative; display: inline-block; }
.tips-pop{
  position:absolute; top:calc(100% + 8px); left:50%;
  transform:translateX(-50%) translateY(-2px);
  opacity:0; pointer-events:none; z-index:3000;
  transition:opacity .12s ease, transform .12s ease;
  overflow:visible;
}
.badge-wrap:hover .tips-pop{
  opacity:1; transform:translateX(-50%) translateY(0);
  /* 保持 pointer-events:none，避免 tip 接住鼠标导致「粘住」/可同时开两个 */
}

/* 关键：箭头放在 tips-box 内部并与顶部严丝合缝 */
.tips-box{
  position:relative;
  max-width:460px; min-width:280px; padding:10px 14px; border-radius:8px;
  background:linear-gradient(180deg,#6B50F0 0%, #5A46E6 100%);
  color:#fff; border:1px solid rgba(0,0,0,.06);
  box-shadow:0 8px 18px rgba(0,0,0,.18);
  font-size:13px; line-height:19px; font-weight:600; letter-spacing:.2px;
  text-align:left; white-space:normal; word-break:break-word; text-shadow:0 1px 0 rgba(0,0,0,.18);
}
.tips-box *{ color:#fff !important; }
.tips-title{ margin:0 0 4px 0; font-size:14px; font-weight:700; line-height:20px; }

/* 箭头本体：与盒子顶部“无缝贴合” */
.tips-arrow{
  position:absolute;
  top:-7px;                 /* 轻微压住边缘，避免缝隙 */
  left:50%;
  transform:translateX(-50%);
  width:0; height:0;
  border-left:7px solid transparent;
  border-right:7px solid transparent;
  border-bottom:7px solid #5A46E6;   /* 与盒子顶部色一致 */
  pointer-events:none;
}

/* 箭头外层阴影：只做外轮廓，不影响贴合度 */
.tips-arrow::after{
  content:"";
  position:absolute;
  left:-8px;
  top:-2px;                 /* 上移形成外阴影 */
  border-left:8px solid transparent;
  border-right:8px solid transparent;
  border-bottom:8px solid rgba(0,0,0,.06);
  z-index:-1;
}

/* =========================================================
   1) bannerAd
   ======================================================= */
.banner-preview{width:100%;height:100%;border-radius:8px;display:inline-flex;flex-direction:column;align-items:flex-start;margin-top: 8px;}
.banner-section{width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:4px;}
.banner-head{display:inline-flex;align-items:center;gap:4px;
  &__title{color:rgba(0,0,0,.80);font-size:14px;font-weight:400;line-height:18.2px;}
}
.banner-body{align-self:stretch;padding:16px;display:flex;flex-direction:column;gap:8px;}
.banner-body--mobile{padding-left: 16px;
  padding-right: 16px;
  /* 保留原有的 overflow:hidden; 如不需要可去掉 */
  overflow: hidden;}
.banner-canvas-box{
  background-repeat: no-repeat;
  background-size: contain;      
  background-position: left center;    
  background-color: #F7F7F7;
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
}
.banner-canvas--pc{width:100%;height:123px;}
.banner-canvas--mb{  width: 100%;     
  height: 123px;}

/* =========================================================
   2) logoAd
   ======================================================= */
   .logoV2__Title{
    color: rgba(0, 0, 0, 0.40);
font-size: 14px;
font-weight: 700;
line-height: 18.20px;
word-wrap: break-word;}
.logoV2{width:100%;height:100%;padding:16px;overflow:hidden;display:inline-flex;align-items:flex-start;gap:26px;}
.logoV2__col{display:inline-flex;flex-direction:column;gap:8px;align-items:flex-start;}
.logoV2__rowSm{display:inline-flex;gap:16px;align-items:center;}
.logoV2__box{overflow:hidden;border-radius:4px;display:inline-flex;justify-content:center;flex-direction:column;}
.logoV2__box--lg{width:216px;height:216px;background:#fff;}
.logoV2__box--sm{width:100px;height:100px;}
.logoV2__inner{position:relative;align-self:stretch;flex:1 1 0;background:rgba(0,0,0,.20);display:flex;justify-content:center;align-items:center;}
.logoV2__ph{width:100%;height:100%;background:#D9D9D9;border-radius:4px;}
.logoV2__inner img{width:100%;height:100%;object-fit:contain;background:#fff;display:block;}
.logo-row{display:flex;gap:12px;justify-content: center !important;}
.logo-row--sm{grid-template-columns:repeat(6,1fr);}
.logo-row--circle{justify-content:flex-start;margin-top:10px;}
.logo-cell{position:relative;background:#fff;border:1px solid #eee;border-radius:8px;overflow:hidden;display:flex;align-items:center;justify-content:center;}
.logo-cell--sm{height:100px;}
.logo-placeholder{width:100%;height:100%;background:#f3f3f3;}
.logo-cell--circle{width:100px;height:100px;border-radius:999px;border:none;background:transparent;}
.logo-cell--circle img,.logo-cell--circle .logo-placeholder{width:100%;height:100%;object-fit:contain;border-radius:999px;display:block;background:#fff;}
/* 参展商名单 logo 卡片：自然宽度，由外层预览区底部统一横向滚动 */
.ad-card{position:relative;width:max-content;min-width:720px;max-width:none;box-sizing:border-box;padding:24px;padding-bottom:32px;background:#fff;border-radius:18px;display:flex;align-items:center;gap:24px;justify-content:flex-start;}
.ad-card__left{flex:1 1 auto;min-width:200px;min-height:100px;display:flex;align-items:center;gap:24px;}
.ad-card__logo{width:100px;height:100px;flex:0 0 100px;border-radius:6px;object-fit:contain;background:#fff;display:block;}
.ad-card__meta{flex:1 1 auto;min-width:160px;align-self:stretch;display:flex;flex-direction:column;justify-content:center;gap:8px;}
.ad-card__name{margin:0;color:#333;font-size:18px;font-weight:700;line-height:21.6px;word-wrap:break-word;}
.ad-card__info-list{margin:.25rem 0 0; padding:0; list-style:none; display:flex; gap:12px; flex-wrap:wrap;}
.ad-card__info-item{font-size:12px;color:#666; .key{margin-right:4px;color:#999;}}
.ad-card__right{display:flex;align-items:center;gap:18px;justify-content:flex-end;flex:0 0 auto;margin-left:auto;}
.ad-card__tag{position:absolute;right:12px;bottom:8px;color:#ACACAC;font-size:12px;pointer-events:none;}
.ad-card__btn{height:37px;padding:10px 20px;background:#fff;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap;flex-shrink:0;}
.ad-card__btn--primary{outline:1px #e64800 solid;outline-offset:-1px;color:#e64800;}
.ad-card__btn--secondary{outline:1px #999 solid;outline-offset:-1px;color:#666;}
.logo-block:has(.ad-card){width:100%;min-width:max-content;box-sizing:border-box;}

/* =========================================================
   3) buttonAd（仅影响 buttonAd 类型）
   ======================================================= */
.AdBlock:has(.btnad) .btnad{width:100%;display:flex;flex-direction:column;align-items:center;}
.AdBlock:has(.btnad) .btnad__list{width:100%;padding:16px;background:transparent;border-radius:0;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;gap:8px;box-sizing:border-box;}
.AdBlock:has(.btnad) .btnad__card{width:150px;height:90px;overflow:hidden;border-radius:4px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:15px;position:relative;}
.AdBlock:has(.btnad) .btnad__bg{width:100%;height:100%;padding:6px;background-color:rgba(0,0,0,0.10);background-repeat:no-repeat;background-position:center center;background-size:contain;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:15px;position:relative;}
.AdBlock:has(.btnad) .btnad__ph{max-width:100%;max-height:100%;display:block;object-fit:contain;}

/* =========================================================
   4) landingAd
   ======================================================= */
.landingad{border-radius:8px;background:transparent;display:flex;flex-direction:column;gap:12px;}
.landingad--cover{padding:0;}
.landingad--cover .landingad__card{background:transparent;}
.landingad--cover .landingad__hero{width:100%;max-width:100%;height:auto;display:block;object-fit:cover;border-top-left-radius:8px;border-top-right-radius:8px;}
.landingad__badge{padding:4px 8px;border-radius:4px;background:rgba(0,0,0,.05);color:rgba(0,0,0,.8);font-size:12px;font-weight:500;width:fit-content;}
.landingad__card{margin:16px ; overflow:hidden;border-radius:8px;background:#fff;display:flex;flex-direction:column;}
.landingad__hero{width:100%;max-width:450px;height:500px;object-fit:cover;background:#F7F7F7;border-top-left-radius:8px;border-top-right-radius:8px;}
.landingad__meta{width:100%;max-width:450px;display:flex;align-items:center;gap:12px;padding:12px;background:#fff;}
.landingad__avatar{width:48px;height:48px;border-radius:999px;object-fit:cover;background:#f3f3f3;flex:0 0 auto;}
.landingad__meta-main{flex:1 1 auto;display:flex;flex-direction:column;gap:6px;min-width:0;}
.landingad__company{color:rgba(0,0,0,.8);font-size:14px;font-weight:700;line-height:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.landingad__chips{display:inline-flex;flex-wrap:wrap;gap:6px;}
.landingad__chip{padding:2px 6px;background:rgba(0,0,0,.03);border-radius:4px;color:rgba(0,0,0,.6);font-size:14px;line-height:21px;}
.landingad__cta{padding:8px 12px;border-radius:999px;background:#CB242B;color:#fff;font-size:12px;font-weight:600;line-height:12px;border:none;cursor:pointer;flex:0 0 auto;}

/* =========================================================
   5) videoAd
   ======================================================= */
.ad-container{width:100%;height:100%;padding:16px;display:inline-flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:10px;}
.ad-frame{position:relative;background:#fff;overflow:hidden;border-radius:4px;background-size:cover;background-position:center;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:10px;}
.ad-frame--sm{width:100%;height:187.25px;}
.ad-frame--lg{width:100%;height:450px;}
.ad-frame--clickable{cursor:pointer;transition:opacity 0.2s ease;}
.ad-frame--clickable:hover{opacity:0.9;}
.ad-play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:inline-flex;align-items:center;justify-content:center;pointer-events:none;filter:drop-shadow(0 6px 20px rgba(0,0,0,.25));}
.ad-play__icon{display:block;width:96px;height:96px;}
.ad-frame--sm .ad-play__icon{width:56px;height:56px;}

/* 视频播放对话框样式 */
.video-player-modal :deep(.modal-body) {
  padding: 0;
}
.video-player-wrapper {
  width: 100%;
  position: relative;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.video-player {
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 80vh;
  display: block;
}
.video-loading {
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* =========================================================
   6) starAd
   ======================================================= */
.starad{width:100%;height:100%;padding:16px;display:inline-flex;flex-direction:column;align-items:flex-start;gap:10px;background:transparent;}
.starad--cover{padding:0;background:transparent;}
.starad__img{width:264px;height:200px;border-radius:8px;object-fit:cover;display:block;}
.starad__img--cover{width:100%;height:auto;border-radius:8px;display:block;object-fit:cover;}
.starad__title{align-self:stretch;text-align:center;display:flex;flex-direction:column;justify-content:center;color:#cd1515;font-size:14px;font-weight:700;line-height:18.2px;}

/* =========================================================
   7) catListAd
   ======================================================= */
.catlistad{
  margin-top: 10px;
  width: 100%;
  min-width: 360px;
  height: auto; /* hug 内容，勿用 100% 被预览区撑高 */
  padding: 8px;
  position: relative;
  background: #FFFFFF;
  border-radius: 8px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  box-sizing: border-box;
}
.catlistad--full{padding:0; background: transparent;}
.catlistad__thumb{
  width: 78px;
  height: 78px;
  position: relative;
  background: #f9f9f9;
  overflow: hidden;
  border-radius: 7.31px;
  flex: 0 0 auto;
  img{width:100%;height:100%;background:#fff;object-fit:cover;display:block;}
}
.catlistad__main{
  flex: 1 1 0;
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.catlistad__title{
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 600;
  line-height: 18.20px;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.catlistad__subtitle{
  color: #666666;
  font-size: 12px;
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 400;
  line-height: 18px;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.catlistad__badge{
  position: absolute;
  right: 12px;
  bottom: 10px;
  color: #BABABA;
  font-size: 12px;
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 400;
  line-height: 12px;
  word-wrap: break-word;
}
.catlistad__full{width:100%;height:auto;display:block;border-radius:8px;}

/* =========================================================
   8) priorityAd（产品卡）
   ======================================================= */
.productCard{
  border-radius:0.5rem;border:1px solid #f3f3f3;display:flex;flex-flow:column nowrap;max-width:20rem;box-shadow:0 0 8px rgba(0,0,0,.2);overflow:hidden;margin:1.5rem;position:relative;
  >.imageWrapper{background:#f9f9f9;position:relative;
    >.imageContainer{>img.img{aspect-ratio:1;object-position:center;object-fit:contain;}}
    >.iconBtns{position:absolute;top:.75rem;right:.75rem;
      >.iconBtnContainer{width:2rem;height:2rem;background:rgba(0,0,0,.4);border-radius:50rem;font-weight:500;line-height:1;font-size:1rem;color:#fff;display:flex;justify-content:center;align-items:center;}
      >.iconBtnContainer:not(:first-child){margin-top:.5rem;}
    }
  }
  >.contentContainer{display:flex;flex-flow:column nowrap;background:#fff;padding:1rem 1rem 1.5rem 1rem;row-gap:.25rem;
    >.productApps{display:flex;gap:5px;
      >div.app_badge{flex:0 0 auto;}
      >.app_badge{border-radius:.25rem;background:rgba(0,0,0,.03);padding:.125rem .25rem;color:rgba(0,0,0,.6);font-size:12px;}
      >div:nth-last-child(2){flex:0 1 auto;text-overflow:ellipsis;overflow:hidden!important;white-space:nowrap;}
    }
    >.productName{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;max-width:fit-content;line-height:1.5;font-size:22px;color:#2e2e2e;font-weight:700;}
    >.productDesc{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;font-size:12px;word-break:break-word;}
    >.companyName{display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;font-size:14px;font-weight:700;word-break:break-word;padding-right:1.5rem;}
    .btns{display:flex;flex-flow:row wrap;gap:.5rem;
      >.enquire-btn{display:flex;align-items:center;padding:.5rem 1rem;border-radius:999px;border:1px solid #e64800;background:#fef0ef;color:#e64800;gap:.25rem;font-size:13px;font-weight:500;line-height:1;}
      >.sendcard-btn{display:flex;align-items:center;padding:.5rem 1rem;border-radius:999px;border:1px solid #999;background:#fff;color:rgba(0,0,0,.8);gap:.25rem;font-size:13px;font-weight:500;line-height:1;}
      >.sendcard-btn .sendcard-btn__icon{width:16px;height:16px;flex-shrink:0;display:block;}
    }
    .product-tags-container{margin:.75rem 0;overflow:hidden;font-weight:400;color:#999;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;text-overflow:ellipsis;
      >span{margin-right:5px;font-size:12px;}
    }

    .pair-tiles{display:inline-flex;gap:8px;align-items:flex-start;justify-content:flex-start;flex:1 1 0;margin-top:.5rem;}
    .pair-tiles__item{width:72px;height:72px;position:relative;overflow:hidden;background: rgba(0,0,0,0.20);border-radius:4px;display:flex;align-items:center;justify-content:center;}
    .pair-tiles__item img{width:100%;height:100%;object-fit:contain;background:#fff;display:block;}

    >.other-products-container{width:100%;
      >.other-products-text{font-size:12px;margin-bottom:.25rem;color:#999;}
      >.other-products{display:grid;column-gap:.5rem;grid-template-columns:repeat(5,1fr);
        >img.img{aspect-ratio:1;object-position:center;object-fit:contain;background:#f9f9f9;overflow:hidden;border-radius:.25rem;border:1px solid #f3f3f3;}
      }
    }
  }
  .adLabel{bottom:.25rem;right:.25rem;font-size:12px;color:#c7c7c7;position:absolute;}
}
.priority-default-grid{width:100%;grid-template-columns:1fr 1fr;gap:.25rem;}
.priority-default-grid img{width:100%;aspect-ratio:1/1;background:#fff;border-radius:.25rem;border:1px solid #f0f0f0;display:block;object-fit:contain;}

/* 仅当页面里出现 Button Ad（.btnad）时，标题与按钮至少 20px 间距 */
.AdBlock:has(.btnad) .PrivewDialogHeader{justify-content:space-between;gap:7px;}
.AdBlock:has(.btnad) .PrivewDialogHeader .PrivewDialogTitle{white-space:nowrap;}
/* Button Ad 时，最外层容器添加背景色和圆角，固定宽度400px */
.AdBlock:has(.btnad).PrivewDialog{width:400px;min-width:400px;max-width:400px;background:rgba(0,0,0,0.03);border-radius:8px;padding:16px;box-sizing:border-box;display:flex;flex-direction:column;gap:0;}
/* Button Ad 时，头部在灰色容器内 */
.AdBlock:has(.btnad) .PrivewDialogHeader{margin-bottom:0;}
/* Button Ad 时，PrivewDialogBody 作为内容区域 */
.AdBlock:has(.btnad) .PrivewDialogBody{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;gap:0;box-sizing:border-box;margin-top:0;}

</style>
